/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantIdentityProviderEntity
 */
export interface TenantIdentityProviderEntity {
    /**
     * サードパーティID
     * @type {string}
     * @memberof TenantIdentityProviderEntity
     */
    thirdPartyId: string;
    /**
     * 認証プロバイダー名
     * @type {string}
     * @memberof TenantIdentityProviderEntity
     */
    name: string;
    /**
     * 認証プロバイダー種別
     * @type {string}
     * @memberof TenantIdentityProviderEntity
     */
    type: string;
    /**
     * デフォルト認証プロバイダーかどうか判別
     * @type {boolean}
     * @memberof TenantIdentityProviderEntity
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the TenantIdentityProviderEntity interface.
 */
export function instanceOfTenantIdentityProviderEntity(value: object): value is TenantIdentityProviderEntity {
    if (!('thirdPartyId' in value) || value['thirdPartyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function TenantIdentityProviderEntityFromJSON(json: any): TenantIdentityProviderEntity {
    return TenantIdentityProviderEntityFromJSONTyped(json, false);
}

export function TenantIdentityProviderEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantIdentityProviderEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'thirdPartyId': json['thirdPartyId'],
        'name': json['name'],
        'type': json['type'],
        'isDefault': json['isDefault'],
    };
}

export function TenantIdentityProviderEntityToJSON(json: any): TenantIdentityProviderEntity {
    return TenantIdentityProviderEntityToJSONTyped(json, false);
}

export function TenantIdentityProviderEntityToJSONTyped(value?: TenantIdentityProviderEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thirdPartyId': value['thirdPartyId'],
        'name': value['name'],
        'type': value['type'],
        'isDefault': value['isDefault'],
    };
}

